export const renderWithPoi = (data) => {
    let label = '';
    if (data.type === 'POI' && data.poi.name) {
        label = `
           <div>
              <strong>${data.poi.name}</strong> 
                <br/>
              <span title="${data.name}">
                ${data.name}
              </span>
           </div>`;
    } else {
        label = `<span title="${data.name}">${data.name}</span`;
    }

    return label;
}